import { SET_SNACKBAR_DATA } from './types'

export const setSnackbarData = data => ({
    type: SET_SNACKBAR_DATA,
    data
})